const features = [
  {
    icon: 'ri-timer-flash-line',
    title: '24小时实时追踪',
    desc: '编辑团队全天候轮班，从深夜到凌晨不间断监控全网动态，确保每一条猛料都能在第一时间推送到你面前，真正的\"不打烊爆料站\"。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '匿名安全投稿',
    desc: '采用端到端加密传输，投稿人身份完全不可追溯。我们守护每一位爆料者的隐私安全，让你敢于说出真相，无后顾之忧。',
  },
  {
    icon: 'ri-global-line',
    title: '全网深度覆盖',
    desc: '从短视频到社交平台，从直播间到私人社群，51每日大赛的追踪网络覆盖全网每一个角落，不放过任何一条有价值的爆料线索。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-10 text-center">
          为什么选择51每日大赛
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((item, idx) => (
            <div key={idx} className="text-center">
              <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-foreground-950 flex items-center justify-center">
                <i className={`${item.icon} text-primary-400 text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}